import styled from 'styled-components';
import TableContainer from '@mui/material/TableContainer';
import { brand } from 'themes/brand';

export const BaseTableContainer = styled(TableContainer)`
  margin-bottom: 50px;

  table {
    border: 1px solid ${brand.border};
    background-color: ${brand.white};
  }

  table thead tr th {
    background-color: ${brand.tint} !important;
    color: ${brand.text} !important;
    text-transform: uppercase;
    font-weight: 600;
  }

  table thead tr th:last-child {
    text-align: right;
  }

  table tbody td svg {
    font-size: 14pt;
  }
`;
